/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：メッセージボックス
 *
 * 作成者：2022/1/5 ノア）黄
 * 最終修正者：2022/1/5 ノア）黄
 *
 */
import Vue from 'vue'
import msgboxVue from './MessageBox.vue'

enum MessageBoxType {
  info = 'info',
  error = 'error'
}

enum ActionType {
  yes = 'yes',
  no = 'no',
  cancel = 'cancel'
}

interface MessageBoxOption {
  type?: MessageBoxType
  title?: string
  width?: string
  showHead?: boolean
  showClose?: boolean
  showYesButton?: boolean
  showNoButton?: boolean
  showCancelButton?: boolean
  yesButtonText?: string
  noButtonText?: string
  cancelButtonText?: string
  yesButtonClass?: string
  noButtonClass?: string
  cancelButtonClass?: string
  message?: string
  callback?: (action: ActionType) => void
  onClose?: any
}

const defaults = {
  type: MessageBoxType.info,
  width: '450px',
  showHead: true,
  showClose: false,
  showYesButton: true,
  showNoButton: true,
  showCancelButton: false,
  yesButtonText: 'はい',
  noButtonText: 'いいえ',
  cancelButtonText: 'キャンセル',
  message: '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  callback: () => {
    return
  },
  onClose: () => {
    return
  }
} as MessageBoxOption

const MessageBoxConstructor = Vue.extend(msgboxVue)

let currentMsg: any, instance: msgboxVue
const msgQueue: Array<any> = []

const MessageBox = (options: MessageBoxOption): void => {
  msgQueue.push({
    options: Object.assign({}, defaults, options)
  })

  showNextMsg()
}

MessageBox.alert = (options: MessageBoxOption) => {
  MessageBox(options)
}

MessageBox.clearQueue = (): void => {
  msgQueue.splice(0, msgQueue.length)
}

const initInstance = () => {
  instance = new MessageBoxConstructor({
    el: document.createElement('div')
  })
}

const showNextMsg = () => {
  if (!instance) {
    initInstance()
  }

  instance.action = ''

  if (!instance.visible) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift()

      const options = currentMsg.options
      for (const prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }

      const oldCb = instance.callback
      instance.callback = action => {
        oldCb(action)
        showNextMsg()
      }

      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visible = true
      })
    }
  }
}

export { MessageBoxType, ActionType, MessageBoxOption, MessageBox }
